export const GOOGLE_SITE_KEY = '6Lcuty0aAAAAABasbnUdjsM62Wu0w3qAZKb7rqnJ';

export const FORMSPREE_URL = 'https://formspree.io/f/mgepzdyo';